<div class="card">
	<div class="p-grid p-ai-center">
		<div class="p-col-6 p-d-flex p-ai-center">
			<img
				src="assets/images/RingCentral logo fullcolor.png"
				alt="RingCentral Logo"
				class="rc-logo p-mr-3"
			/>
			<h2 class="p-m-0">Integration</h2>
		</div>
		<div class="p-col-6 p-d-flex p-jc-end p-ai-center">
			<div class="p-mr-2">Enable Integration</div>
			<p-inputSwitch
				[(ngModel)]="isEnabled"
				(onChange)="toggleEnabled()"
			></p-inputSwitch>
		</div>
	</div>
</div>

<div class="card">
	<form
		[formGroup]="ringCentralForm"
		(ngSubmit)="saveSettings()"
	>
		<h4 class="p-mb-3">Connection Status</h4>

		<div
			class="p-d-flex p-ai-center p-mb-4"
			*ngIf="!isConnected"
		>
			<div class="p-mr-3">
				<i
					class="pi pi-exclamation-circle p-text-secondary"
					style="font-size: 2rem"
				></i>
			</div>
			<div class="p-mr-4">
				<p class="p-m-0 p-text-bold">Not Connected</p>
				<small class="p-text-secondary">Connect your RingCentral account to enable SMS features.</small>
			</div>
			<button
				pButton
				pRipple
				type="button"
				label="Connect RingCentral"
				icon="pi pi-link"
				(click)="connectRingCentral()"
				class="p-button-primary"
			></button>
		</div>

		<div
			class="p-d-flex p-ai-center p-mb-4"
			*ngIf="isConnected"
		>
			<div class="p-mr-3">
				<i
					class="pi pi-check-circle p-text-success"
					style="font-size: 2rem"
				></i>
			</div>
			<div class="p-mr-4">
				<p class="p-m-0 p-text-bold">Connected</p>
				<small class="p-text-secondary">Your RingCentral account is successfully linked.</small>
			</div>
			<div>
				<button
					pButton
					pRipple
					type="button"
					label="Re-authenticate"
					icon="pi pi-refresh"
					(click)="connectRingCentral()"
					class="p-button-outlined p-button-secondary p-mr-2"
				></button>
				<button
					pButton
					pRipple
					type="button"
					label="Disconnect"
					icon="pi pi-trash"
					(click)="disconnectRingCentral()"
					class="p-button-danger p-button-text"
				></button>
			</div>
		</div>

		<hr class="p-my-4" />

		<h4 class="p-mb-3">SMS Configuration</h4>

		<div class="p-fluid">
			<div class="p-field">
				<label for="phoneNumber">RingCentral Phone Number</label>
				<div class="p-inputgroup">
					<span class="p-inputgroup-addon"><i class="pi pi-phone"></i></span>
					<input
						id="phoneNumber"
						type="text"
						pInputText
						formControlName="phoneNumber"
						placeholder="+1 (555) 123-4567"
					/>
				</div>
				<small class="p-text-secondary">The phone number used for outbound SMS messages.</small>
			</div>
		</div>

		<div class="p-d-flex p-jc-end">
			<button
				pButton
				pRipple
				type="submit"
				label="Save Changes"
				icon="pi pi-save"
				[disabled]="ringCentralForm.invalid || ringCentralForm.pristine"
			></button>
		</div>
	</form>
</div>

<div class="card">
	<div class="p-grid p-ai-center">
		<div class="p-col-12 p-md-8">
			<h4 class="p-m-0">Webhook</h4>
			<p class="p-m-0 p-mb-2 p-text-secondary">Receives incoming SMS messages from RingCentral.</p>

			<div
				class="p-d-flex p-ai-center"
				[ngSwitch]="isWebhookLoading ? 'loading' : webhookStatus?.state"
			>
				<ng-container *ngSwitchCase="'loading'">
					<i class="pi pi-spin pi-spinner p-mr-2"></i>
					<span>Checking RingCentral…</span>
				</ng-container>
				<ng-container *ngSwitchCase="'not-connected'">
					<i class="pi pi-info-circle p-text-secondary p-mr-2"></i>
					<span class="p-text-secondary">Connect RingCentral to set up the webhook.</span>
				</ng-container>
				<ng-container *ngSwitchCase="'active'">
					<i class="pi pi-check-circle p-text-success p-mr-2"></i>
					<span>
						Receiving incoming SMS
						<small
							*ngIf="webhookStatus.expiresAt"
							class="p-text-secondary"
						>· expires {{ webhookStatus.expiresAt | date: 'mediumDate' }}</small>
					</span>
				</ng-container>
				<ng-container *ngSwitchCase="'missing'">
					<i class="pi pi-exclamation-triangle webhook-warning p-mr-2"></i>
					<span>Not receiving incoming SMS: no webhook is set up.</span>
				</ng-container>
				<ng-container *ngSwitchCase="'inactive'">
					<i class="pi pi-exclamation-triangle webhook-warning p-mr-2"></i>
					<span>Not receiving incoming SMS: RingCentral reports the webhook as {{ webhookStatus.status }}.</span>
				</ng-container>
				<ng-container *ngSwitchCase="'error'">
					<i class="pi pi-exclamation-triangle webhook-warning p-mr-2"></i>
					<span>Can't reach RingCentral: {{ webhookStatus.error }}</span>
				</ng-container>
			</div>

			<small
				*ngIf="!isEnabled && (webhookStatus?.state === 'missing' || webhookStatus?.state === 'inactive')"
				class="p-text-secondary"
			>Enable the integration to set up the webhook.</small>
		</div>

		<div
			class="p-col-12 p-md-4 p-d-flex p-jc-end p-ai-center"
			*ngIf="!isWebhookLoading"
			[ngSwitch]="webhookStatus?.state"
		>
			<button
				*ngSwitchCase="'active'"
				pButton
				type="button"
				label="Remove webhook"
				icon="pi pi-trash"
				class="p-button-danger p-button-text"
				[loading]="isWebhookSaving"
				(click)="removeWebhook()"
			></button>
			<button
				*ngSwitchCase="'missing'"
				pButton
				type="button"
				label="Set up webhook"
				icon="pi pi-link"
				[loading]="isWebhookSaving"
				[disabled]="!isEnabled"
				(click)="setUpWebhook()"
			></button>
			<ng-container *ngSwitchCase="'inactive'">
				<button
					pButton
					type="button"
					label="Remove"
					icon="pi pi-trash"
					class="p-button-danger p-button-text p-mr-2"
					[disabled]="isWebhookSaving"
					(click)="removeWebhook()"
				></button>
				<button
					pButton
					type="button"
					label="Repair webhook"
					icon="pi pi-refresh"
					[loading]="isWebhookSaving"
					[disabled]="!isEnabled"
					(click)="setUpWebhook()"
				></button>
			</ng-container>
			<button
				*ngSwitchCase="'error'"
				pButton
				type="button"
				label="Retry"
				icon="pi pi-refresh"
				class="p-button-outlined p-button-secondary"
				(click)="loadWebhookStatus()"
			></button>
		</div>
	</div>
</div>
